// @ngInject
function FileDataImportApiServiceV2($q, DS, DSHttpAdapter, ResourcesService, $window) {

    var endpoint = 'productimport';

    return {
        checkForConnectionWithArticleData: checkForConnectionWithArticleData,
        connectWithArticleData: connectWithArticleData,
        disableAutoArticleData: disableAutoArticleData,
        createProductImportEntry: createProductImportEntry,
        deleteProductImportFile: deleteProductImportFile,
        getArticleCollections: getArticleCollections,
        getArticleTypes: ResourcesService.apiFactory.get(endpoint + '/articletypesbrief'),
        getColumnMapping: getColumnMapping,
        getImportFiles: getImportFiles,
        getImportFile: getImportFile,
        getLocations: getLocations,
        getOrderCollections: getOrderCollections,
        getSuppliers: getSuppliers,
        getCompanies:getCompanies,
        saveColumnMapping: saveColumnMapping,
        updateImportFile: updateImportFile,
        updateFileRow: updateFileRow,
        updateFileRows: updateFileRows,
        deleteFileRow: deleteFileRow,
        finalizeImport: finalizeImport,
        getItemGroups: getItemGroups,
        getItemGroupsOnFileId: getItemGroupsOnFileId,
        getDepartments: ResourcesService.apiFactory.get(endpoint + '/departmentsbrief'),
        getSubCategories: ResourcesService.apiFactory.get(endpoint + '/subcategoriesbrief'),
        getCurrencyDefault: ResourcesService.apiFactory.get(endpoint + '/currencies/default'),
        getCurrencies: ResourcesService.apiFactory.get(endpoint + '/currencies'),
        validateImportFileWithId: validateImportFileWithId,
        checkImportFileDataExistence: checkImportFileDataExistence,
        getSalesChannels: ResourcesService.apiFactory.get(endpoint + '/saleschannels'),
        getCountries: ResourcesService.apiFactory.get(endpoint + '/countries'),
        getMissingSiblingRows: getMissingSiblingRows,
        getPdfLabels: getPdfLabels,
        existsSiblingPrices: existsSiblingPrices,
        getTenantConfig: getTenantConfig,
        generateBarcodesForFile: generateBarcodesForFile
    };

    function getTenantConfig() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + "/tenantconfig").then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function existsSiblingPrices(importFileId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + "/existssiblingprices/" + importFileId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }
    
    function generateBarcodesForFile(importFileId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + "/generatebarcodes/" + importFileId).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getMissingSiblingRows(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + "/siblingrows/", request).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s]){1,}.pdf/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function getPdfLabels(importFileId, locationId) {
        var deferred = $q.defer();
        var request = {
            importFileId: importFileId,
            locationId: locationId
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + "/labels", {params: request, responseType: 'arraybuffer'}).then(function(response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'labels.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;   
    }

    function checkForConnectionWithArticleData(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/check/articledata', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function connectWithArticleData(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/connect/articledata', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function disableAutoArticleData(request){
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/disable/autoarticledata', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createProductImportEntry(requestDto) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'productimport/create', requestDto).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getImportFiles(page, filter, pageSize) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/files', {params: params}).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getImportFile(importFileId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/files/' + importFileId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getSuppliers() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/suppliers').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getLocations() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/locations').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getArticleCollections(onlyCurrent) {
        var deferred = $q.defer();

        var request = {
            onlyCurrent: onlyCurrent
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'productimport/articlecollections', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getOrderCollections(onlyCurrent) {
        var deferred = $q.defer();

        var request = {
            onlyCurrent: onlyCurrent
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'productimport/ordercollections', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }



    function saveColumnMapping(companyId, mappingRequest) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'productimport/mapping/' + companyId, mappingRequest).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateImportFile(importFile) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'productimport/', importFile).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateFileRow(importRow) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'productimport/row', importRow).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateFileRows(importRows) {
        var deferred = $q.defer();

        var request = {
            rows: importRows
        };

        DSHttpAdapter.PUT(DS.defaults.basePath + 'productimport/rows', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteFileRow(importRow) {
        var deferred = $q.defer();

        DSHttpAdapter.DEL(DS.defaults.basePath + 'productimport/row/' + importRow.id).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function finalizeImport(importFileId, priceUpdateGroupingLevel) {
        var deferred = $q.defer();

        var request = {
            importFileId: importFileId,
            grouping: priceUpdateGroupingLevel
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'productimport/finalize/', request).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        // DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/finalize/' + importFileId).then(function(response) {
        //     deferred.resolve(response.data);
        // }, function(error) {
        //     deferred.reject(handleError(error));
        // });

        return deferred.promise;
    }

    function getColumnMapping(companyId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/mapping/' + companyId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteProductImportFile(importId) {
        var deferred = $q.defer();

        DSHttpAdapter.DEL(DS.defaults.basePath + 'productimport/files/' + importId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getItemGroups() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/itemgroupbriefs').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getItemGroupsOnFileId(fileId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/itemgroupbriefs/' + fileId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getCompanies() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/suppliers').then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function validateImportFileWithId(importFileId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/validatefile/' + importFileId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function checkImportFileDataExistence(importFileId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'productimport/checkimportfile/' + importFileId).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular.module('filedataimportv2.api', [])
    .factory('FileDataImportApiServiceV2', FileDataImportApiServiceV2);
